import React from 'react';
import './Staff.css'


const Staff = () => {
    return(

        <>

<section id="team" class="team section-bg">
      <div class="container" data-aos="fade-up">
        <div class="section-header">
          <h3 className='h3-tag'>STAFF</h3>
          <p className='p-tag'>Meet some of our hard working staff making sure our students excel</p>
        </div>

        <div class="row">

          <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <div class="member">
              <img src={"images/testimonials/client-1.jpg"} class="img-fluid" alt=""/>
              <div class="member-info">
                <div class="member-info-content">
                  <h4>Kwodwo Nelson</h4>
                  <span>Head Master</span>
                  <div class="social">
                    <a href="#lu"><i class="fa-brands fa-twitter"></i></a>
                    <a href="#lu"><i class="fa-brands fa-facebook"></i></a>
                    <a href="#lu"><i class="fa-brands fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div class="member">
              <img src={"images/testimonials/client-2.jpg"} class="img-fluid" alt=""/>
              <div class="member-info">
                <div class="member-info-content">
                  <h4>Sarah Ankarah</h4>
                  <span>Assistant Headmaster</span>
                  <div class="social">
                    <a href="#lu"><i class="fa-brands fa-twitter"></i></a>
                    <a href="#lu"><i class="fa-brands fa-facebook"></i></a>
                    <a href="#lu"><i class="fa-brands fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="300">
            <div class="member">
              <img src={"images/testimonials/client-3.jpg"} class="img-fluid" alt=""/>
              <div class="member-info">
                <div class="member-info-content">
                  <h4>Leticia Adu Cindy</h4>
                  <span>Head of All Teachers</span>
                  <div class="social">
                    <a href="#lu"><i class="fa-brands fa-twitter"></i></a>
                    <a href="#lu"><i class="fa-brands fa-facebook"></i></a>
                    <a href="#lu"><i class="fa-brands fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="400">
            <div class="member">
              <img src={"images/testimonials/client-4.jpg"} class="img-fluid" alt=""/>
              <div class="member-info">
                <div class="member-info-content">
                  <h4>Amanda Henaopeh</h4>
                  <span>Accountant</span>
                  <div class="social">
                    <a href="#lu"><i class="fa-brands fa-twitter"></i></a>
                    <a href="#lu"><i class="fa-brands fa-facebook"></i></a>
                    <a href="#lu"><i class="fa-brands fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>

        </>

    );
}

export default Staff;